import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '#src/cn.ts'

export type TypographyPUIProps = HTMLAttributes<HTMLParagraphElement>

export const TypographyPUI = forwardRef<
  HTMLParagraphElement,
  TypographyPUIProps
>(({ className, ...delegated }, ref) => (
  <p ref={ref} className={cn('text-sm', className)} {...delegated} />
))
TypographyPUI.displayName = 'TypographyPUI'
